import 'owa-bootstrap'; // Important that owa-bootstrap come first, in order to bootstrap webpack settings
import 'owa-application'; // Import owa-application here to include globalStyles

export { default as bootstrap } from './bootstrap';
